import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../../components/elements/LoadingButton";
import Grid from "@material-ui/core/Grid/Grid";
import {connect, setStore} from "trim-redux";
import CurrencyTextField from '@unicef/material-ui-currency-textfield'
import {currencySymbol} from "../../../../config/values";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import withWidth from "@material-ui/core/withWidth/withWidth";
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import {updateRedux} from "../../../../config/Security";
import ChooseDate from "../../../components/elements/ChooseDate";
import FullTimeChooserModal from "../../../components/elements/FullTimeChooserModal";

class ModifySinglePricing extends React.Component {

    state = {
        fields:{
            price:'',
            priceR:'',
            discount_price:'',
            discount_priceR:'',
            inventory:null,
            priceWhole:'',
            priceWholeR:'',
            discount_priceWhole:'',
            discount_priceWholeR:'',
            inventory_for_wholesale:null,
            pricing_status:'present',
        },
        product:null,
        percent: '',
        percentWhole: '',
        errors:{},
        loading: true,
        SubmitLoading: false,
        has_wholesale:false,
        confirmed: true,
        pricing_id:this.props.id,
        editMode:false,
        has_discount_validity:false,
        discount_price_validity:null
    };
    classes = this.props.classes;
    async componentDidMount(){
        await this.setState({
            pricing_id:this.props.id,
        })
        await this.loadData();
    }
    componentDidUpdate(prevProps){
        if(this.state.pricing_id !== this.props.id){
            this.setState({
                pricing_id:this.props.id,
            })
        }

    }
    async loadData(){
        let {pricing_id} = this.state;
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/pricing/getById/${pricing_id}`, config)
                .then(response => {
                    this.setState({
                        fields: {
                            price: response.data.price,
                            priceR: response.data.price,
                            discount_price: response.data.discount_price === null ? "" : response.data.discount_price,
                            discount_priceR: response.data.discount_price === null ? "" : response.data.discount_price,
                            inventory:response.data.inventory,
                            inventory_for_wholesale:response.data.inventory_for_wholesale,
                            priceWhole:response.data.price_whole === null ? "" : response.data.price_whole,
                            priceWholeR:response.data.price_whole === null ? "" : response.data.price_whole,
                            discount_priceWhole:response.data.discount_price_whole === null ? "" : response.data.discount_price_whole,
                            discount_priceWholeR:response.data.discount_price_whole === null ? "" : response.data.discount_price_whole,
                            pricing_status: response.data.status === null ? "" : response.data.status === "soon" ?  response.data.status : response.data.inventory > 0 ? "present" : "sold",

                        },
                        editMode:true,
                        loading:false,
                        product: response.data.product,
                        confirmed: response.data.confirmed,
                        has_wholesale: response.data.has_wholesale,
                        pricing_id: response.data.id,
                        percent : response.data.discount_price > 0 ? Math.max(0, Math.floor((response.data.price - response.data.discount_price)*100/response.data.price)) : '',
                        percentWhole : response.data.discount_price_whole > 0 ? Math.max(0, Math.floor((response.data.price_whole - response.data.discount_price_whole)*100/response.data.price_whole)) : '',
                        discount_price_validity : !!response.data.discount_price_validity ? response.data.discount_price_validity  : null,
                        has_discount_validity : !!response.data.discount_price_validity,

                    })

                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    handleChange(e){
        let {errors,fields,percent,percentWhole} = this.state;
        let target = e.target;
        if(target.name === "price"){
            fields.priceR = target.value.replace(/,/ig, '');
            if(!!fields.discount_priceR)
                percent = Math.max(0, Math.floor((fields.priceR - fields.discount_priceR)*100/fields.priceR));

        }else if (target.name === "discount_price") {
            fields.discount_priceR = target.value.replace(/,/ig, '');
            if (!!fields.priceR)
                percent = Math.max(0, Math.floor((fields.priceR - fields.discount_priceR) * 100 / fields.priceR));
            if (parseInt(fields.discount_priceR) >= parseInt(fields.priceR)) {
                fields.discount_price = '';
                fields.discount_priceR = '';
                percent = ''
            }
        }if(target.name === "priceWhole"){
            fields.priceWholeR = target.value.replace(/,/ig, '');
            if(!!fields.discount_priceWholeR)
                percentWhole = Math.max(0, Math.floor((fields.priceWholeR - fields.discount_priceWholeR)*100/fields.priceWholeR));

        }else if (target.name === "discount_priceWhole") {
            fields.discount_priceWholeR = target.value.replace(/,/ig, '');
            if (!!fields.priceWholeR)
                percentWhole = Math.max(0, Math.floor((fields.priceWholeR - fields.discount_priceWholeR) * 100 / fields.priceWholeR));
            if (parseInt(fields.discount_priceWholeR) >= parseInt(fields.priceWholeR)) {
                fields.discount_priceWhole = '';
                fields.discount_priceWholeR = '';
                percentWhole = ''
            }
        }else if(target.name === "inventory" || target.name === "inventory_for_wholesale"){
            if(parseInt(target.value) > 0){
                fields[target.name] = Math.abs(parseInt(target.value));
            }else{
                fields[target.name] = '';
            }
        }else{
            fields[target.name] = target.value;
        }
        errors[target.name] = "";

        this.setState({
            fields,
            percent,
            percentWhole

        });
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;
        if(!fields.pricing_status) {
            formIsValid = false;
            errors['pricing_status'] = Translate.emptyField;
        }
        if(fields.pricing_status === "present"){
            if(!fields.inventory){
                formIsValid = false;
                errors['inventory'] = Translate.emptyField;
            }

        }

        //price
        if(!fields.priceR){
            formIsValid = false;
            errors['price'] = Translate.emptyField;
        }else{
            if(fields.discount_priceR !== null){
                if(fields.discount_priceR > 0){
                    console.log(fields.discount_priceR,fields.priceR)
                    if(fields.discount_priceR >= fields.priceR){
                        formIsValid = false;
                        errors['discount_price'] = Translate.discountMoreThanPrice;
                    }
                }
            }
            if(!!fields.inventory_for_wholesale && this.state.has_wholesale && fields.pricing_status === "present"){
                console.log(fields.inventory_for_wholesale);
                if(!fields.priceWholeR){
                    formIsValid = false;
                    errors['priceWhole'] = Translate.emptyField;
                }else if (fields.priceWholeR >= fields.priceR) {
                    formIsValid = false;
                    errors['priceWhole'] = Translate.wholesalePriceShouldBeLess;
                }
                if(!fields.inventory){
                    formIsValid = false;
                    errors['inventory'] = Translate.emptyField;
                }else if(parseInt(fields.inventory_for_wholesale) > parseInt(fields.inventory)){
                    formIsValid = false;
                    errors['inventory_for_wholesale'] = Translate.wholeSaleInventoryLessThanInventory;
                }
            }
            if(fields.discount_priceWholeR !== null){
                if(fields.discount_priceWholeR > 0){
                    if(fields.discount_priceWholeR > fields.priceWholeR){
                        formIsValid = false;
                        errors['discount_priceWhole'] = Translate.discountMoreThanPrice;
                    }
                }
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
            console.log(errors)
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { fields,editMode,confirmed,has_wholesale,pricing_id,has_discount_validity,discount_price_validity} = this.state;
        let data = new FormData();
        data.append('price', fields.priceR);
        data.append('discount_price', fields.discount_priceR);
        data.append('price_whole', fields.priceWholeR);
        data.append('discount_price_whole', fields.discount_priceWholeR);
        data.append('inventory', fields.inventory);
        data.append('inventory_for_wholesale', fields.inventory_for_wholesale);
        data.append('confirmed',  confirmed ? 1 : 0);
        data.append('has_wholesale',  has_wholesale ? 1 : 0);
        data.append('manage',  this.props.manage ? 1 : 0);
        data.append('pricing_id',  pricing_id);
        data.append('p_status', fields.pricing_status);
        data.append('discount_price_validity', (!!has_discount_validity && !!fields.discount_priceR) ? discount_price_validity : null);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/pricing/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(editMode ? Translate.dataEdited : Translate.dataAdded, {
                    variant: 'success',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
                updateRedux();
                this.props.reload();
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(editMode ?  Translate.dataEditingFailed : Translate.dataAddingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }

    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }

    handleChangeConfirmed(){
        this.setState({
            confirmed: !this.state.confirmed,
        })
    }
    handleChangePercent(e){
        let percent = e.target.value;
        let fields = this.state.fields;
        let price = this.state.fields.priceR;
        if(!!price){
            fields['discount_priceR'] = price - (price*percent/100);
            fields['discount_price'] = price - (price*percent/100);
        }
        if(parseInt(percent) === 0){
            fields.discount_price = '';
            fields.discount_priceR = '';
            percent = ''
        }
        this.setState({
            percent,
            fields
        })
    }
    handleDelete(){
        let {pricing_id} = this.state;
        let data = new FormData();
        data.append('pricing_id',  pricing_id);
        this.setState({
            loading: false
        });
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/pricing/delete`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.deleteData, {
                    variant: 'success',
                });
                this.props.reload();
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.deleteDataFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });
    }
    handleChangePercentWhole(e){
        let percent = e.target.value;
        let fields = this.state.fields;
        let price = this.state.fields.priceWholeR;
        if(!!price){
            fields['discount_priceWholeR'] = price - (price*percent/100);
            fields['discount_priceWhole'] = price - (price*percent/100);
        }
        if(parseInt(percent) === 0){
            fields.discount_priceWhole = '';
            fields.discount_priceWholeR = '';
            percent = ''
        }
        this.setState({
            percentWhole:percent,
            fields
        })
    }
    handleDiscountDate(date){
        this.setState({
            discount_price_validity:date
        })
    }
    render(){
        let {fields, errors,percent,percentWhole,SubmitLoading,editMode,confirmed,loading} = this.state;
        let {user,attribute,value} = this.props;
        return (
            <div className="makeSinglePricingHolder">
                {
                    loading ?   <div style={{paddingTop:100,paddingBottom:100,textAlign:"center"}}>
                            <CircularProgress size={35}/>
                        </div> :
                        <Grid container spacing={2}  alignItems='center' justifyContent="center">
                            <Grid item xs={12} md={11}>
                                <Grid container spacing={2}>
                                    {/*<Grid item xs={12}>
                                        {
                                            !editMode ?
                                                null
                                                :
                                                <>
                                                    {
                                                        !! user.role.permission.manageShops ?
                                                            <>
                                                                <Alert
                                                                    severity="info"
                                                                    action={
                                                                        <FormControlLabel
                                                                            style={{marginRight:10,color: !confirmed ? "#ed1d1d" : ""}}
                                                                            control={
                                                                                <Switch
                                                                                    checked={confirmed}
                                                                                    onChange={this.handleChangeConfirmed.bind(this)}
                                                                                    value={confirmed}
                                                                                    color="primary"
                                                                                />
                                                                            }
                                                                            label={confirmed ? Translate.confirmed : Translate.unConfirmed}
                                                                        />
                                                                    }
                                                                >
                                                                    {Translate.confirmationStatus}
                                                                </Alert>
                                                            </>
                                                            :
                                                            confirmed ?
                                                                <Alert severity="success">
                                                                    {Translate.yourPricingIsActive}
                                                                </Alert>
                                                                :
                                                                <Alert severity="warning">
                                                                    {Translate.yourPricingIsInchecking}
                                                                </Alert>
                                                    }
                                                </>

                                        }
                                    </Grid>*/}
                                    <Grid item xs={12}>
                                        <TextField
                                            select
                                            required
                                            type="text"
                                            size="small"
                                            fullWidth
                                            label={Translate.pricing_status}
                                            name="pricing_status"
                                            value={fields.pricing_status}
                                            onChange={this.handleChange.bind(this)}
                                            variant="outlined"
                                            error={!!errors['pricing_status']}
                                        >
                                            <MenuItem value={'present'}>
                                                {Translate.present_pricing}
                                            </MenuItem>
                                            <MenuItem value={'sold'}>
                                                {Translate.sold_pricing}
                                            </MenuItem>
                                            <MenuItem value={'soon'}>
                                                {Translate.soon_pricing}
                                            </MenuItem>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} md={6} >
                                        <CurrencyTextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            size="small"
                                            currencySymbol={currencySymbol}
                                            decimalPlaces={0}
                                            value={fields.price}
                                            id="price"
                                            label={Translate.price}
                                            name="price"
                                            onChange={this.handleChange.bind(this)}
                                            error = {!!errors['price']}
                                            helperText={errors['price']}
                                        />
                                    </Grid>
                                    <Grid item xs={4} md={2}>
                                        <TextField
                                            variant="outlined"
                                            value={percent}
                                            fullWidth
                                            id="percent"
                                            size="small"
                                            label={Translate.discount_percent}
                                            name="percent"
                                            autoComplete="percent"
                                            onChange={this.handleChangePercent.bind(this)}
                                            error = {!!errors['percent']}
                                            helperText={errors['percent']}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={8} md={4}>
                                        <CurrencyTextField
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            currencySymbol={currencySymbol}
                                            decimalPlaces={0}
                                            value={fields.discount_price}
                                            id="discount_price"
                                            label={Translate.discount_price}
                                            name="discount_price"
                                            onChange={this.handleChange.bind(this)}
                                            error = {!!errors['discount_price']}
                                            helperText={errors['discount_price']}
                                        />
                                    </Grid>
                                    {
                                        fields.discount_priceR > 0 &&
                                        <>
                                            <Grid item xs={12} md={!!this.state.has_discount_validity ? 6 : 12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={this.state.has_discount_validity}
                                                            onChange={(e) => this.setState({has_discount_validity: !this.state.has_discount_validity})}
                                                            name="has_discount_validity"
                                                            color="primary"
                                                        />
                                                    }
                                                    label={Translate.has_discount_validity}
                                                />

                                            </Grid>
                                            {
                                                !!this.state.has_discount_validity &&
                                                <Grid item xs={12} md={6} style={{display:"flex",justifyContent:"flex-end"}}>
                                                    <FullTimeChooserModal
                                                        input={this.state.discount_price_validity}
                                                        handleDate={this.handleDiscountDate.bind(this)}
                                                        label={Translate.discountDate}
                                                    />
                                                </Grid>
                                            }
                                        </>
                                    }

                                    <Grid item xs={12} md={6}>
                                        {
                                            fields.pricing_status === "present" &&
                                            <TextField
                                                required
                                                variant="outlined"
                                                value={fields.inventory}
                                                fullWidth
                                                size="small"
                                                type="number"
                                                label={Translate.inventory}
                                                placeholder={Translate.inventoryDesc}
                                                name="inventory"
                                                onChange={this.handleChange.bind(this)}
                                                error = {!!errors['inventory']}
                                                helperText={errors['inventory']}
                                            />
                                        }
                                    </Grid>
                                    {
                                        (this.state.product.situation !== "worked" && fields.pricing_status === "present") &&
                                        <>
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={this.state.has_wholesale}
                                                            onChange={(e) => this.setState({has_wholesale: !this.state.has_wholesale})}
                                                            name="has_wholesale"
                                                            color="primary"
                                                        />
                                                    }
                                                    label={Translate.activeWholesale}
                                                />
                                            </Grid>
                                            {
                                                !!this.state.has_wholesale &&
                                                <>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            variant="outlined"
                                                            value={fields.inventory_for_wholesale}
                                                            fullWidth
                                                            size="small"
                                                            type="number"
                                                            label={Translate.inventory_for_wholesale}
                                                            placeholder={Translate.inventoryWholeSaleDesc}
                                                            name="inventory_for_wholesale"
                                                            onChange={this.handleChange.bind(this)}
                                                            error = {!!errors['inventory_for_wholesale']}
                                                            helperText={errors['inventory_for_wholesale']}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6} >
                                                        <CurrencyTextField
                                                            variant="outlined"
                                                            fullWidth
                                                            size="small"
                                                            currencySymbol={currencySymbol}
                                                            decimalPlaces={0}
                                                            value={fields.priceWhole}
                                                            id="priceWhole"
                                                            label={Translate.priceWhole}
                                                            name="priceWhole"
                                                            onChange={this.handleChange.bind(this)}
                                                            error = {!!errors['priceWhole']}
                                                            helperText={errors['priceWhole']}
                                                        />
                                                    </Grid>
                                                    {/*<Grid item xs={4} md={2}>
                                                <TextField
                                                    variant="outlined"
                                                    value={percentWhole}
                                                    fullWidth
                                                    size="small"
                                                    label={Translate.discount_percent_whole}
                                                    name="percentWhole"
                                                    onChange={this.handleChangePercentWhole.bind(this)}
                                                    error = {!!errors['percentWhole']}
                                                    helperText={errors['percentWhole']}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={8} md={4}>
                                                <CurrencyTextField
                                                    variant="outlined"
                                                    fullWidth
                                                    size="small"
                                                    currencySymbol={currencySymbol}
                                                    decimalPlaces={0}
                                                    value={fields.discount_priceWhole}
                                                    label={Translate.discount_priceWhole}
                                                    name="discount_priceWhole"
                                                    onChange={this.handleChange.bind(this)}
                                                    error = {!!errors['discount_priceWhole']}
                                                    helperText={errors['discount_priceWhole']}
                                                />
                                            </Grid>*/}
                                                </>
                                            }
                                        </>

                                    }


                                    <Grid item xs={12}>
                                        <LoadingButton
                                            styleForParent={{
                                                float: "left",
                                                margin:0
                                            }}
                                            startIcon={<SaveRoundedIcon/>}
                                            variant="contained"
                                            color="primary"
                                            onClick = {this.handleSubmit.bind(this)}
                                            loading = {SubmitLoading}
                                        >
                                            {Translate.save}
                                        </LoadingButton>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                }

            </div>

        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withWidth()(withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(ModifySinglePricing)))));